import { TableBody, TableHead } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { CheckToken } from "../../login/AccessToken";
import axios from "../../login/Axios-interceptor";
import "./AdminComponents.scss";
// import axios from "axios";

import {
  DataGrid,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import { toast } from "react-toastify";

function FacilityList({ refreshList }) {
  const [userData, setUserData] = useState([]);
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const [accessToken, setAccessToken] = useState("");
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const history = useHistory();
  // useEffect(() => {
  //   if (
  //     (sessionStorage.getItem("accessToken") == undefined &&
  //       sessionStorage.getItem("accessToken") == null) ||
  //     (sessionStorage.getItem("roleType") !== "admin" &&
  //       sessionStorage.getItem("roleType") !== "customer admin")
  //   ) {
  //     history.push("/login");
  //   }
  // }, []);
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };

  useEffect(() => {
    if (
      (sessionStorage.getItem("roleType") === "admin" ||
        sessionStorage.getItem("roleType") === "customer admin") &&
      Token()
    ) {
      axios
        .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_facilities/`, {
          headers: headers,
        })
        .then((res) => {
          console.log(res);
          const userDataWithId = res.data.facility_list.map(
            (facility, index) => ({
              ...facility,
              id: index + 1,
            })
          );
          setUserData(userDataWithId);
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
        });
    }
  }, [authToken, refreshList]);
  const getRowClassName = (params) => {
    return "custom-row";
  };
  console.log(userData);
  const sortedUserData = [...userData].sort(
    (a, b) => new Date(b.date_of_creation) - new Date(a.date_of_creation)
  );
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        margin: "auto",
        width: "100%",
        maxWidth: "1200px", // Set a max width for large screens
        padding: "1rem",
      }}
    >
      <h1 style={{ textAlign: "center" }}>Facility List</h1>
      {userData !== undefined && userData.length > 0 ? (
        <div style={{ width: "100%" }}>
          <DataGrid
            rows={sortedUserData}
            columns={[
              { field: "partner", headerName: "Partner ", width: 120 },
              { field: "customer", headerName: "Customer ", width: 120 },
              { field: "facility_id", headerName: "Facility ID", width: 160 },
              {
                field: "facility_name",
                headerName: "Facility Name",
                width: 150,
              },
              {
                field: "facility_type",
                headerName: "Facility Type",
                width: 150,
              },
              {
                field: "subscription_type",
                headerName: "Subscription Type",
                width: 200,
              },
              {
                field: "endpoint",
                headerName: "Facility Endpoint",
                width: 160,
                valueFormatter: (params) => {
                  return params.value || "No Endpoint provided";
                },
              },

              {
                field: "date_of_creation",
                headerName: "Date of Creation",
                width: 200,
                valueFormatter: (params) =>
                  new Date(params.value).toDateString() +
                  " " +
                  new Date(params.value).toLocaleTimeString(),
              },
              {
                field: "trial",
                headerName: "Trial Status",
                width: 100,
                renderCell: (params) => (
                  <div style={{ fontWeight: "bold" }}>
                    {params.value ? "On Trial" : "Not on Trial"}
                  </div>
                ),
              },
              {
                field: "active",
                headerName: "Active",
                width: 100,
                renderCell: (params) => (
                  <div
                    style={{
                      color: params.value ? "green" : "red",
                      fontWeight: "bold",
                    }}
                  >
                    {params.value ? "Active" : "Inactive"}
                  </div>
                ),
              },
            ]}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 10 },
              },
            }}
            pageSizeOptions={[5, 10]}
            getRowId={(row) => row.id}
            components={{
              Toolbar: () => (
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div style={{ display: "flex" }}>
                    <GridToolbarColumnsButton />
                    <GridToolbarFilterButton />
                    <GridToolbarDensitySelector />
                  </div>
                </div>
              ),
            }}
            getRowClassName={getRowClassName}
          />
        </div>
      ) : (
        <h3>No Facility is added!!</h3>
      )}
    </div>
  );
}

export default FacilityList;
